<template>
  <div class="title-wrap" :style="{
    textAlign: formData.textAlign,
    background: formData.background
  }">
    <div v-show="formData.showLine" :style="{
      background: formData.color
     }"
         class="line"></div>
    <div class="title-text" :style="{
      fontSize: formData.fontSize,
      color: formData.color
     }">
      {{ formData.text || '标题' }}
    </div>
    <div v-show="formData.showLine" :style="{
      background: formData.color
     }"
         class="line"></div>
  </div>
</template>

<script>
export default {
  name: "title",
  components: {},
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        text: '标题',
        textAlign: 'center',
        fontSize: '18px',
        color: '#333',
        background: '#fff',
        showLine: true
      }
    }
  },
  created() {
    this.getData()
  },
  mounted() {
  },
  methods: {
    getData () {
      const { text, textAlign, fontSize, showLine, background, color } = this.config.moduleData
      this.formData.text = text || '标题'
      this.formData.textAlign = textAlign || 'center'
      this.formData.fontSize = fontSize ? fontSize + 'px' : '18px'
      this.formData.background = background || '#fff'
      this.formData.color = color || '#333'
      this.formData.showLine = showLine
    }
  }
}
</script>

<style scoped>
.title-wrap {
  padding: 8px 8px 16px;
  background: #fff;
}
.title-text {
  display: inline-block;
}
.line {
  width: 50px;
  height: 2px;
  background-color: rgba(151, 151, 151, 0.6);
  display: inline-block;
  vertical-align: 5px;
  margin: 0 15px;
}
</style>
